import { gql } from '@apollo/client'

export const GET_NEW_PATH_ENROLLMENT = gql`
  query getNewPathEnrollment($id: ID!, $offset: Int!, $limit: Int!) {
    enrollment(id: $id) {
      id
      activatedAt
      availableUntil
      unlimited
      schoolProduct {
        id
        availableTimeLength
        expireDate
        title
      }
      progressCard {
        id
        courseProgressCards(
          pagination: { offset: $offset, limit: $limit }
          ordenation: { by: "id", direction: "asc" }
        ) {
          id
          total
          progress
          courseId
          completed
          course {
            id
            imageUrl
            name
            kind
            courseModules(pagination: { offset: 0, limit: 1 }, main: true) {
              nodes {
                id
                courseContents {
                  nodes {
                    id
                    available
                    lesson {
                      id
                      title
                      releaseAt
                      releaseAfter
                      courseClassReleaseOffset
                      lockAt
                      lockAfter
                      createdAt
                      courseContentId
                      media {
                        id
                        type
                        duration
                        hostKey
                        originUrl
                        providerKey
                        host
                        fileExt
                        text
                        organizationUuid
                      }
                      coverImage {
                        cdnFileUrl
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
